// libs
import styled from "styled-components";
// theme
import { typography, colors } from "src/theme";
// const
import devices from "src/constants/media";

export const FormContainer = styled.form``;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-top: 56px;

  @media ${devices.tablet} {
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 32px;
  }
`;
export const ButtonBox = styled.div`
  @media ${devices.tablet} {
    width: 90px;
  }
`;
export const ButtonBoxCancel = styled.div`
  margin-top: 12px;

  @media ${devices.tablet} {
    width: 90px;
    margin-right: 12px;
    margin-top: 0;
  }
`;
